<template>
	<modal
		:modal-id="modalId"
		:title="modalTitle"
		:preloader="preloader"
		@submit="submit"
		@close-modal="closeModal"
	>
		<template slot="body">
			<app-overlay-loader v-if="preloader" />
			<form
				class="mb-0"
				:class="{ 'loading-opacity': preloader }"
				ref="form"
				:data-url="'calendar/save-setting-date'"
			>

				<div class="form-group row align-items-center">
					<label for="inputs_from_date" class="col-sm-3 mb-0">
						From Date
					</label>
					<app-input
						id="inputs_from_date"
						class="col-sm-9"
						type="date"
						v-model="inputs.from_date"
						:placeholder="'From Date'"
						:required="true"
					/>
				</div>

				<div class="form-group row align-items-center">
					<label for="inputs_to_date" class="col-sm-3 mb-0">
						To Date
					</label>
					<app-input
						id="inputs_to_date"
						class="col-sm-9"
						type="date"
						v-model="inputs.to_date"
						:placeholder="'To Date'"
						:required="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_color" class="col-sm-3 mb-0">
						Color
					</label>
                    <div class="col-sm-9 d-flex align-items-center gap-2">

                        <input 
                            type="text" 
                            v-model="inputs.color" 
                            placeholder="#ff0000" 
                            maxlength="7"
                        	:required="true"
                            class="form-control"
                        />
                        <input type="color" class="box-color" v-model="inputs.color" />


                    </div>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_description" class="col-sm-3 mb-0">
						Description
					</label>
                    <app-input
                        id="inputs_description"
                        class="col-sm-9"
                        type="text"
                        v-model="inputs.description"
                        :placeholder="'Description'"
                        :required="true"
                    />
				</div>
			</form>
		</template>
	</modal>
</template>

<script>
import { FormMixin } from "../../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../../Mixins/ModalMixin";
export default {
	name: "ModalForm",
	mixins: [FormMixin, ModalMixin],
	props: {
		tableId: String,
		formId: String,
	},
	data() {
		return {
			preloader: false,
			inputs: {
                id : '',
                from_date : '',
                to_date : '',
                color : '',
                description : ''
			},
			modalId: this.formId,
			modalTitle: 'Setting Date',
		};
	},
	created() {
		if (this.selectedUrl) {
			this.preloader = true;
		}
	},
	methods: {
		submit() {
			this.save(this.inputs);
		},
		afterSuccess(response) {
			if (response.data.status === 'success') {
				this.$toastr.s(response.data.message || 'Data updated successfully');
			} else {
				this.$toastr.e(response.data.message || 'Failed');
			}
		},
		afterSuccessFromGetEditData(response) {
			this.inputs = response.data.data;
			this.preloader = false;
		},
	},
};
</script>
<style scoped>
    .box-color{
        width: 11%;
        background: transparent;
        border: transparent;
    }
</style>